import { useRef, useEffect, useState } from "react";
import { Box, TextField, Typography, Link as MuiLink } from "@mui/material";
import axios from "axios";
import { toast } from "sonner";
import swal from "sweetalert";
import Schedules from "./Schedules";
import Observation from "../observations/Observation";
import CustomLoader from "../static/CustomLoader";
import { getDropDownVal } from "../dropdownUtils";
import {
  MasterPage,
  MasterToolbar,
  MasterButton,
  MasterSearch,
  MasterGrid,
  MasterDialog,
  MasterConfirmDialog,
} from "../static/Masterpage";

const ScheduleListing = () => {
  const apiUrl = localStorage.getItem("apiUrl");
  const dbTokenData = localStorage.getItem("dbTokenData");
  const orgcode = localStorage.getItem("custCode") || "ptw";

  const headers = {
    Authorization: `Bearer ${dbTokenData}`,
    "Content-Type": "application/json",
    dbMaster: "",
  };

  const [userData, setUserData] = useState([{}]);
  const [filterData, setFilterData] = useState([{}]);
  const [serach, setSerach] = useState("");
  const [selectedData, setSelectedData] = useState("");
  const [loading, setLoading] = useState(false);
  const [selectedDatacode, setSelectedDatacode] = useState("");
  const [selectedFactory, setSelectedFactory] = useState("");
  const [shareResponse, setShareResponse] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const [auditcodeList, setAuditcodeList] = useState([{}]);
  const [selectedauditcodeList, setSelectedauditcodeList] = useState([{}]);
  const [usedCodeList, setUsedCodeList] = useState([{}]);
  const [statusOptions, setStatusOptions] = useState([]);
  const [ScheduleList, setScheduleList] = useState([{}]);
  const [showConfirm, setShowConfirm] = useState(false);
  const [showShareModal, setShowShareModal] = useState(false);
  const [shareInfoModal, setShareInfoModal] = useState(false);
  const [shareEmail, setShareEmail] = useState("");
  const [density, setDensity] = useState("standard");
  const [addShow, setAddShow] = useState(false);
  const [editShow, setEditShow] = useState(false);
  const [scheduleeditShow, setscheduleEditShow] = useState(false);

  const searchRef = useRef(null);

  useEffect(() => {
    if (searchRef.current) {
      searchRef.current.focus();
    }
  }, []);

  const addHandleShow = () => {
    setAddShow(true);
  };

  const addHandleClose = () => {
    setShowConfirm(true);
  };

  const editHandleShow = () => {
    if (selectedData.length > 1 || selectedData.length === 0) {
      toast.warning("Please Select only one value");
      return;
    }

    setEditShow(true);
  };

  const editHandleClose = () => {
    setShowConfirm(true);
  };

  const scheduleeditHandleClose = () => {
    setShowConfirm(true);
  };

  const handleShareShow = () => {
    if (selectedData.length > 1 || selectedData.length === 0) {
      toast.warning("Please Select only one value");
      return;
    }

    setShowShareModal(true);
  };

  const handleConfirmClose = () => {
    setShowConfirm(false);
    setAddShow(false);
    setEditShow(false);
    setscheduleEditShow(false);
  };

  const handleCancelClose = () => {
    setShowConfirm(false);
  };

  const validateEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  const handleSucessModel = (data) => {
    setShareResponse(data);
    setShowShareModal(false);
    setShareEmail("");
    setShareInfoModal(true);
  };

  const handlecloseShareInfo = () => {
    setShareInfoModal(false);
    setShareResponse(null);
  };

  const handlecloseShare = () => {
    setShowShareModal(false);
    setShareEmail("");
  };

  const handleShareConfirm = async () => {
    if (!shareEmail) {
      toast.warning("Please enter an email address");
      return;
    }

    if (!validateEmail(shareEmail)) {
      toast.error("Please enter a valid email address");
      return;
    }

    if (!selectedFactory) {
      toast.warning("Please select one schedule to share");
      return;
    }

    setLoading(true);

    try {
      const payload = {
        shaduleId: selectedFactory,
        email: shareEmail,
        subject: "Auditee Link",
        message: "Please open the link to view: {{SIGN_LINK}}",
        orgCode: orgcode,
      };

      const response = await axios.post(apiUrl + "share/linkGenarte", payload, {
        headers,
      });

      if (response.data && response.data.cd === 0) {
        handleSucessModel(response.data);
      } else {
        toast.error(response.data.description || "Error in sharing");
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to share. Please try again.");
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      field: "code",
      headerName: "Schedule ID",
      width: 110,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "factoryName",
      headerName: "Factory",
      width: 240,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "userName",
      headerName: "User",
      width: 180,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "schstdate",
      headerName: "Schedule Date",
      width: 190,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "inspectiontitle",
      headerName: "Inspection Title",
      flex: 1,
      minWidth: 240,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "statusName",
      headerName: "Status",
      width: 160,
      headerAlign: "center",
      align: "center",
    },
  ];

  useEffect(() => {
    fetchUSer();
  }, [refresh]);

  const fetchUSer = async () => {
    try {
      axios
        .get(apiUrl + "user", {
          headers,
        })
        .then((response) => {
          setUsedCodeList(response.data);

          const sectionOption = response.data.map((op) => ({
            value: op.empcode,
            label: op.userid,
          }));

          setUsedCodeList(sectionOption);

          fetchAudeteeCode(sectionOption);
        })
        .catch((error) => {
          setUsedCodeList([{}]);
        });
    } catch (error) {
      setUsedCodeList([{}]);
    }
  };

  const fetchAudeteeCode = async (UserOption) => {
    const userdetails = JSON.parse(localStorage.getItem("user"));

    const empcode = userdetails?.empcode;

    try {
      axios
        .get(apiUrl + "auditee", {
          headers,
        })
        .then((response) => {
          setAuditcodeList(response.data);

          const sectionOption = response.data.map((op) => ({
            value: op.code,
            label: op.name,
          }));

          setAuditcodeList(sectionOption);

          fetchStatusOptions(UserOption, sectionOption);

          const filteredList = response.data
            .filter((item) => item.user === empcode || item.user === 0)
            .map((op) => ({
              value: op.code,
              label: op.name,
            }));

          setSelectedauditcodeList(filteredList);
        })
        .catch((error) => {
          setAuditcodeList([{}]);
          setSelectedauditcodeList([{}]);
        });
    } catch (error) {
      setAuditcodeList([{}]);
      setSelectedauditcodeList([{}]);
    }
  };

  const fetchStatusOptions = (UserOption, auditOption) => {
    try {
      const response = getDropDownVal("STAT");

      const actOption = response.map((op) => ({
        value: op.code,
        label: op.value,
      }));

      setStatusOptions(actOption);

      fetchData(UserOption, auditOption, actOption);
    } catch (error) {
      console.log("error");
    }
  };

  const fetchData = async (UserOption, auditOption, actOption) => {
    try {
      axios
        .get(apiUrl + "schedule", {
          headers,
        })
        .then((response) => {
          const sectionOption = response.data.map((op) => ({
            value: op.code,
            label: op.inspectiontitle,
            auditee: op.auditeecode,
          }));

          setScheduleList(sectionOption);

          const enrichedData = response.data.map((item) => {
            const matchedStatus = actOption.find(
              (sku) => sku.value === item.status,
            );

            const matchedUser = UserOption.find(
              (sku) => sku.value === item.user,
            );

            const matchedFactory = auditOption.find(
              (sku) => sku.value === item.auditeecode,
            );

            return {
              ...item,
              statusName: matchedStatus ? matchedStatus.label : item.status,
              userName: matchedUser ? matchedUser.label : item.user,
              factoryName: matchedFactory
                ? matchedFactory.label
                : item.auditeecode,
            };
          });

          setUserData(enrichedData);
          setFilterData(enrichedData);
          setRefresh(false);
          setSelectedData("");
        })
        .catch((error) => {
          console.log("error " + error);
          setUserData([{}]);
        });
    } catch (error) {
      setUserData([{}]);
    }
  };

  const handlesearch = (event) => {
    const getSearchdata = event.target.value;

    const getSearch = event.target.value.toLowerCase();

    if (getSearch.length > 0) {
      const searchdata = filterData.filter((item) =>
        Object.keys(item).some((key) =>
          String(item[key]).toLowerCase().includes(getSearch),
        ),
      );

      setUserData(searchdata);
    } else {
      setUserData(filterData);
    }

    setSerach(getSearchdata);
  };

  return (
    <>
      <MasterPage>
        <MasterToolbar
          actions={
            <>
              <MasterButton
                variant="add"
                tooltip="Create new Schedule"
                onClick={addHandleShow}
                disabled={loading}
              >
                Add
              </MasterButton>

              <MasterButton
                variant="update"
                tooltip="Edit Selected Schedule"
                onClick={editHandleShow}
                disabled={loading}
              >
                Update
              </MasterButton>

              <MasterButton
                variant="primary"
                tooltip="Share Selected Schedule"
                onClick={handleShareShow}
                disabled={loading}
              >
                Share
              </MasterButton>
            </>
          }
          search={
            <MasterSearch
              tooltip="Search..."
              value={serach}
              onChange={handlesearch}
              inputRef={searchRef}
            />
          }
        />

        <MasterGrid
          density={density}
          onDensityChange={(newDensityString) => setDensity(newDensityString)}
          rows={
            userData !== null &&
            userData.length > 0 &&
            Object.keys(userData[0]).length !== 0 &&
            userData
          }
          columns={columns}
          onSelectionModelChange={(ids) => setSelectedData(ids)}
          onRowClick={(params) => {
            setSelectedFactory(params.row.auditeecode);
            setSelectedDatacode(params.row.code);
          }}
        />
      </MasterPage>

      {loading && <CustomLoader />}

      <MasterDialog
        open={addShow}
        onHide={addHandleClose}
        title="Add Schedule"
        maxWidth="lg"
      >
        <Schedules
          selectedId=""
          mode="A"
          onHide={addHandleClose}
          setRefresh={setRefresh}
          auditcodeList={auditcodeList}
          selectedauditcodeList={selectedauditcodeList}
          usedCodeList={usedCodeList}
          statusOptions={statusOptions}
        />
      </MasterDialog>

      <MasterDialog
        open={editShow}
        onHide={editHandleClose}
        title="Update Schedule"
        maxWidth="lg"
      >
        <Schedules
          selectedId={selectedData && selectedData[0]}
          mode="U"
          onHide={editHandleClose}
          setRefresh={setRefresh}
          auditcodeList={auditcodeList}
          selectedauditcodeList={selectedauditcodeList}
          usedCodeList={usedCodeList}
          statusOptions={statusOptions}
        />
      </MasterDialog>

      <MasterDialog
        open={scheduleeditShow}
        onHide={scheduleeditHandleClose}
        title="View Inspection Details"
        maxWidth="lg"
      >
        <Observation
          selectedId={selectedData && selectedData[0]}
          selectedDatacode={selectedDatacode}
          mode1="U"
          onHide={scheduleeditHandleClose}
          setRefresh={setRefresh}
          usedCodeList={usedCodeList}
          scheduleList={ScheduleList}
        />
      </MasterDialog>

      <MasterDialog
        open={showShareModal}
        onHide={handlecloseShare}
        title="Share Schedule"
        maxWidth="sm"
      >
        <Box
          sx={{
            px: {
              xs: 1.5,
              sm: 2,
            },
            py: 2,
          }}
        >
          <Typography
            sx={{
              mb: 1,
              fontSize: 13,
              fontWeight: 600,
              color: "#33485C",
            }}
          >
            Email Address
          </Typography>

          <TextField
            fullWidth
            size="small"
            type="email"
            placeholder="Enter Email"
            value={shareEmail}
            onChange={(e) => setShareEmail(e.target.value)}
          />

          
          <div className="bottombtn">
          <button
            className="btn btn-success"
            disabled={loading}
            onClick={handleShareConfirm}
          >
            Share
          </button>
          <button className="btn btn-danger" onClick={handlecloseShare}>
            Cancel
          </button>
        </div>
        </Box>
      </MasterDialog>

      <MasterDialog
        open={shareInfoModal}
        onHide={handlecloseShareInfo}
        title="Share Details"
        maxWidth="sm"
      >
        <Box
          sx={{
            px: {
              xs: 1.5,
              sm: 2,
            },
            py: 2,
          }}
        >
          <Box
            sx={{
              display: "grid",
              gap: 1.5,
            }}
          >
            <Box>
              <Typography
                sx={{
                  fontSize: 12,
                  fontWeight: 600,
                  color: "#64748B",
                  mb: 0.25,
                }}
              >
                Email
              </Typography>

              <Typography
                sx={{
                  fontSize: 13.5,
                  color: "#1B2733",
                }}
              >
                {shareResponse?.email}
              </Typography>
            </Box>

            <Box>
              <Typography
                sx={{
                  fontSize: 12,
                  fontWeight: 600,
                  color: "#64748B",
                  mb: 0.25,
                }}
              >
                OTP
              </Typography>

              <Typography
                sx={{
                  fontSize: 13.5,
                  fontWeight: 600,
                  color: "#123B5D",
                }}
              >
                {shareResponse?.otp}
              </Typography>
            </Box>

            <Box>
              <Typography
                sx={{
                  fontSize: 12,
                  fontWeight: 600,
                  color: "#64748B",
                  mb: 0.5,
                }}
              >
                Share Link
              </Typography>

              <MuiLink
                href={shareResponse?.link}
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  display: "block",
                  fontSize: 13,
                  color: "#2676C9",
                  wordBreak: "break-all",
                  textDecoration: "none",
                  "&:hover": {
                    textDecoration: "underline",
                  },
                }}
              >
                {shareResponse?.link}
              </MuiLink>
            </Box>

            {shareResponse?.description && (
              <Box
                sx={{
                  p: 1.25,
                  borderRadius: "8px",
                  backgroundColor: "#EFFAF4",
                  border: "1px solid #C8E8D6",
                  color: "#26764D",
                  fontSize: 12.5,
                }}
              >
                {shareResponse.description}
              </Box>
            )}
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              mt: 2,
            }}
          >
            <MasterButton variant="primary" onClick={handlecloseShareInfo}>
              OK
            </MasterButton>
          </Box>
        </Box>
      </MasterDialog>

      <MasterConfirmDialog
        show={showConfirm}
        title="Close Confirmation"
        message="Are you sure you want to close this modal?"
        onConfirm={handleConfirmClose}
        onCancel={handleCancelClose}
      />
    </>
  );
};

export default ScheduleListing;
